const LIST_AUTOMATIONS_SUCCESS = "LIST_TEMPLATES_SUCCESS_V1";
const LIST_AUTOMATIONS_FAILURE = "LIST_TEMPLATES_FAILURE_V1";
const SET_AUTOMATION = "SET_AUTOMATION_V1";
const LIST_AUTOMATION_BLUEPRINTS_SUCCESS =
	"LIST_AUTOMATION_BLUEPRINTS_SUCCESS_V1";
const UPDATE_AUTOMATION_EVENT = "UPDATE_AUTOMATION_EVENT_V1";
const ADD_AUTOMATION_EVENT = "ADD_AUTOMATION_EVENT_V1";
const RESET_AUTOMATION_EVENTS = "RESET_AUTOMATION_EVENTS_V1";
const CREATE_AUTOMATION_SUCCESS = "CREATE_AUTOMATION_SUCCESS_V1";
const CREATE_AUTOMATION_FAILURE = "CREATE_AUTOMATION_FAILURE_V1";
const GET_AUTOMATION_FAILURE = "GET_AUTOMATION_FAILURE_V1";
const GET_AUTOMATION_SUCCESS = "GET_AUTOMATION_SUCCESS_V1";
const LIST_AUTOMATION_BLUEPRINTS_FAILURE =
	"LIST_AUTOMATION_BLUEPRINTS_FAILURE_V1";
const UPDATE_ACTIVE_AUTOMATION = "UPDATE_ACTIVE_AUTOMATION_V1";
const UPDATE_ACTIVE_AUTOMATION_SUCCESS = "UPDATE_ACTIVE_AUTOMATION_SUCCESS_V1";
const LIST_AUTOMATION_ACTIONS_SUCCESS = "LIST_AUTOMATION_ACTIONS_SUCCESS_V1";
const GET_ACTION_SUCCESS = "GET_ACTION_SUCCESS_V1";
const DELETE_AUTOMATION_EVENT = "DELETE_AUTOMATION_EVENT_V1";
const UPDATE_ACTION_FAILURE = "UPDATE_ACTION_FAILURE_V1";
const UPDATE_ACTION_SUCCESS = "UPDATE_ACTION_SUCCESS_V1";
const CREATE_ACTION_SUCCESS = "CREATE_ACTION_SUCCESS_V1";
const CREATE_ACTION_FAILURE = "CREATE_ACTION_FAILURE_V1";
const DEACTIVATE_AUTOMATION_SUCCESS = "DEACTIVATE_AUTOMATION_SUCCESS_V1";
const ACTIVATE_AUTOMATION_SUCCESS = "ACTIVATE_AUTOMATION_SUCCESS_V1";
const UPDATE_AUTOMATION_EVENTS = "UPDATE_AUTOMATION_EVENTS_V1";
const DELETE_ACTION_SUCCESS = "DELETE_ACTION_SUCCESS_V1";
const DELETE_ACTION_FAILURE = "DELETE_ACTION_FAILURE_V1";
const UPDATE_AUTOMATION_SELECTED_EVENT = "UPDATE_AUTOMATION_SELECTED_EVENT_V1";
const UPDATE_AUTOMATION_GENERAL_ISSUES = "UPDATE_AUTOMATION_GENERAL_ISSUES_V1";
const SET_EDITOR_MODE = "SET_EDITOR_MODE_V1";
const GET_ACTION_STATS_SUCCESS = "GET_ACTION_STATS_SUCCESS_V1";
const TOGGLE_HIDE_STATS = "TOGGLE_HIDE_STATS_V1";
const UPDATE_AUTOMATION_STATS_SUCCESS = "UPDATE_AUTOMATION_STATS_SUCCESS_V1";

export {
	CREATE_ACTION_SUCCESS,
	CREATE_ACTION_FAILURE,
	LIST_AUTOMATIONS_FAILURE,
	LIST_AUTOMATIONS_SUCCESS,
	SET_AUTOMATION,
	LIST_AUTOMATION_BLUEPRINTS_SUCCESS,
	ADD_AUTOMATION_EVENT,
	UPDATE_AUTOMATION_EVENT,
	RESET_AUTOMATION_EVENTS,
	CREATE_AUTOMATION_FAILURE,
	CREATE_AUTOMATION_SUCCESS,
	GET_AUTOMATION_FAILURE,
	GET_AUTOMATION_SUCCESS,
	LIST_AUTOMATION_BLUEPRINTS_FAILURE,
	UPDATE_ACTIVE_AUTOMATION,
	UPDATE_ACTIVE_AUTOMATION_SUCCESS,
	LIST_AUTOMATION_ACTIONS_SUCCESS,
	GET_ACTION_SUCCESS,
	DELETE_AUTOMATION_EVENT,
	UPDATE_ACTION_SUCCESS,
	UPDATE_ACTION_FAILURE,
	DEACTIVATE_AUTOMATION_SUCCESS,
	ACTIVATE_AUTOMATION_SUCCESS,
	UPDATE_AUTOMATION_EVENTS,
	DELETE_ACTION_SUCCESS,
	DELETE_ACTION_FAILURE,
	UPDATE_AUTOMATION_SELECTED_EVENT,
	UPDATE_AUTOMATION_GENERAL_ISSUES,
	SET_EDITOR_MODE,
	GET_ACTION_STATS_SUCCESS,
	TOGGLE_HIDE_STATS,
	UPDATE_AUTOMATION_STATS_SUCCESS,
};
